<div class="titulo__contenedorLabelHora">
    <div class="titulo__labelSuperior">
        <h5>{{titulo}}</h5>
    </div>
    <div class="titulo__hora" *ngIf="visualizarHora">
        <div class="titulo__labelUltimaHora">
            <h5>Hora ult. Actualizaci&#243;n</h5>
        </div>
        <div class="titulo__horaActualizada">
            <h5>{{horaActual}}</h5>
        </div>
    </div>
</div>
